
import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { FormVerificationService } from 'app/shared/services/form-verification.service';
import { LocalStorageService } from '../../shared';

@Component({
  selector: 'app-form-e',
  templateUrl: './app-form-e.component.html',
})
export class AppFormEComponent implements OnInit {
  public formName = 'rubrique_E_droits';
  public formIsValid = true;
  form: FormGroup;
  items: FormArray;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly formVerificationService: FormVerificationService,
    private readonly localStorageService: LocalStorageService
  ) {}

  get formData() { return <FormArray>this.form.get('items'); }

  ngOnInit (): void {
    this.form = new FormGroup({
      e_grevant_bien: new FormControl(),
      e_preciser_nature: new FormControl(),
      e_rente_viagere: new FormControl(),
    });

    this.form = this.formBuilder.group({
      items: this.formBuilder.array([ this.createItem() ])
    });

    this.restoreFromStorage();

    // Auto-sauvegarder le brouillon du formulaire pendant la saisie
    this.form.valueChanges.subscribe(() => this.saveToStorage());
  }

  /**
   * Réinitialise les champs en les désactivant en cas de changement sur les champs à choix
   */
  resetFormRubrique() {
    const choix = this.form.get('items').get('0').get('e_grevant_bien').value;

    switch (choix) {
      case true:
        this.form.get('items').get('0').get('e_preciser_nature').enable();
        this.form.get('items').get('0').get('e_rente_viagere').enable();
        break;
      case false:
        this.form.get('items').get('0').get('e_preciser_nature').disable();
        this.form.get('items').get('0').get('e_rente_viagere').disable();
        break;
    }
  }

  createItem(): FormGroup {
    return this.formBuilder.group({
      e_grevant_bien: false,
      e_preciser_nature: '',
      e_rente_viagere: ''
    });
  }

  /**
   * Sauvegarde le brouillon dans le localStorage.
   */
  private saveToStorage(): void {
    this.localStorageService.save('form_e', {
      values: this.formData.at(0).value
    });
  }

  /**
   * Restaure le brouillon depuis le localStorage.
   * Après restauration, réapplique l'état enabled/disabled des champs conditionnels.
   */
  private restoreFromStorage(): void {
    const saved = this.localStorageService.load('form_e');
    if (!saved) { return; }
    if (saved.values) {
      this.formData.at(0).patchValue(saved.values, { emitEvent: false });
      // Restaurer l'état enabled/disabled
      this.resetFormRubrique();
    }
  }

  get priceTip(): string {
    return 'Montant en euros (ex: 1500 ou 1500.50)';
  }

  get pricePlaceHolder(): string {
    return 'ex: 1500.50';
  }

  /**
   * Vérifie la validité d'un champ pour l'affichage conditionnel des erreurs.
   * Retourne la classe CSS ou un booléen selon le paramètre type.
   */
  checkFieldValidity(dirty, type = 'validity'): any {
    const valid = this.formIsValid;
    switch (type) {
      case 'class':
        return (!valid && !dirty) ? 'is-invalid' : '';
      default:
        return (!valid && !dirty);
    }
  }

  /**
   * Renvoit un boolean en fonction de la validité des formulaires présent dans l'étape courante
   *
   * @param type
   * @returns {boolean}
   */
  isInputValid(): boolean {
    const choix = this.form.get('items').get('0').get('e_grevant_bien').value;
    const rente = this.form.get('items').get('0').get('e_rente_viagere').value;
    return !choix || this.formVerificationService.isDataPriceValid(rente);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/app-form-e/app-form-e.component.ts